export const SET_PAGE_STATE = 'SET_PAGE_STATE';
export const RESET_PAGE_STATE = 'RESET_PAGE_STATE';
